import { WindowWidthAtom } from "@/hooks/dim-hook";
import { useAtom } from "jotai";

const mobileProductBox = 450;

export const useIsSmallScreen = () => {
  const [w] = useAtom(WindowWidthAtom);
  const isSamllScreen = w <= mobileProductBox;
  return isSamllScreen;
};
